const BASE_ROUTE = 'user-root'

export const ROUTE_NAMES = {
  LIST: 'instructions-eur',
  DETAILS_DAILY: 'instruction-eur-details-daily',
  DETAILS_MONTHLY: 'instruction-eur-details-monthly'
}

const ROUTES = {
  [BASE_ROUTE]: {
    name: BASE_ROUTE,
    path: 'instructions-eur'
  },
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'list'
  },
  [ROUTE_NAMES.DETAILS_DAILY]: {
    name: ROUTE_NAMES.DETAILS_DAILY,
    path: 'daily-detail/:date'
  },
  [ROUTE_NAMES.DETAILS_MONTHLY]: {
    name: ROUTE_NAMES.DETAILS_MONTHLY,
    path: 'monthly-detail/:date'
  }
}

export default [
  {
    name: ROUTES[BASE_ROUTE].name,
    path: ROUTES[BASE_ROUTE].path,
    component: {
      template: '<router-view/>',
      name: 'InstructionsEurModule'
    },
    children: [
      {
        name: ROUTES[ROUTE_NAMES.LIST].name,
        path: ROUTES[ROUTE_NAMES.LIST].path,
        component: (resolve) => require(['./views/list'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS_DAILY].name,
        path: ROUTES[ROUTE_NAMES.DETAILS_DAILY].path,
        component: (resolve) => require(['./views/detailsDaily'], resolve)
      },
      {
        name: ROUTES[ROUTE_NAMES.DETAILS_MONTHLY].name,
        path: ROUTES[ROUTE_NAMES.DETAILS_MONTHLY].path,
        component: (resolve) => require(['./views/detailsMonthly'], resolve)
      }
    ]
  }
]
